// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"920":"fa5bc47d948d7124","2752":"402bfcbc371beef3","3239":"17c159bd0422e499"}[chunkId] + ".css";
};